import { computed, ComputedRef } from 'vue';
import { useI18n } from 'vue-i18n';

import { orderformService } from '@exchange/libs/order/order-form/service/src';
import { OrderType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';

export interface OrderTypeOption {
  label: ComputedRef<string>;
  type: OrderType;
}

const useOrderTypes = () => {
  const { t } = useI18n({ useScope: 'global' });

  const getOrderLabel = (tKey: OrderType) => computed(() => t(`fundamentals.orders.type.${tKey}_SHORT`) as string);

  const storedSide = computed(() => orderformService.data.side);
  const storedType = computed(() => orderformService.data.type);

  const market: OrderTypeOption = {
    label: getOrderLabel(OrderType.MARKET),
    type: OrderType.MARKET,
  };
  const limit: OrderTypeOption = {
    label: getOrderLabel(OrderType.LIMIT),
    type: OrderType.LIMIT,
  };
  const stop: OrderTypeOption = {
    label: getOrderLabel(OrderType.STOP),
    type: OrderType.STOP,
  };

  return {
    storedSide,
    storedType,
    market,
    limit,
    stop,
  };
};

export default useOrderTypes;
